import { BiSolidDashboard } from "react-icons/bi";
import { IRouteConfig } from "@lib/types/Routes";
import { ROUTES } from "@lib/constants";
import { MdPayments } from "react-icons/md";
import { TbAdjustmentsCog } from "react-icons/tb";
import { HiMiniQueueList } from "react-icons/hi2";
import { FaBell, FaUser } from "react-icons/fa";

const providerRoutesConfig: IRouteConfig[] = [
  {
    id: "dashboards",
    title: "dashboards",
    messageId: "sidebar.dashboards",
    type: "group",
    icon: <BiSolidDashboard />,
    showInBottomNav: false,
    children: [
      {
        id: ROUTES.PROVIDER.DASHBOARD,
        url: ROUTES.PROVIDER.DASHBOARD,
        title: "Provider Dashboard",
        messageId: "sidebar.provider.dashboard",
        icon: <BiSolidDashboard />,
        type: "item",
        showInBottomNav: true,
      },
    ],
  },

  {
    id: "menu",
    title: "Menu",
    messageId: "sidebar.menu",
    type: "group",
    icon: <HiMiniQueueList />,
    showInBottomNav: false,
    children: [
      {
        id: ROUTES.PROVIDER.PAYMENT_HISTORY.LIST,
        url: ROUTES.PROVIDER.PAYMENT_HISTORY.LIST,
        title: "Payment History",
        messageId: "sidebar.provider.paymentHistory",
        icon: <MdPayments />,
      },

      {
        id: ROUTES.PROVIDER.PAYMENT_TRANSACTION_CONFIG.LIST,
        url: ROUTES.PROVIDER.PAYMENT_TRANSACTION_CONFIG.LIST,
        title: "Payment Transaction Configs",
        messageId: "sidebar.provider.paymentTransactionConfigs",
        icon: <TbAdjustmentsCog />,
      },
    ],
  },

  // don't show in sidebar
  {
    id: "myProfile",
    title: "My Profile",
    messageId: "sidebar.myProfile",
    type: "item",
    url: ROUTES.MY_PROFILE.LIST,
    icon: <FaUser />,
    dontShowInSidebar: true,
  },
  {
    id: "notifications",
    title: "Notifications",
    messageId: "sidebar.notifications",
    type: "item",
    url: ROUTES.NOTIFICATIONS.LIST,
    icon: <FaBell />,
    dontShowInSidebar: true,
  },
];

export default providerRoutesConfig;
